var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"py-5 my-md-5 px-sm-5 mx-md-5"},[_c('h1',{staticClass:"mb-5",staticStyle:{"font-size":"5em"}},[_vm._v(" "+_vm._s(_vm.titulo)+" ")]),_vm._t("default",function(){return [_c('h3',[_vm._v("Aparentemente não há nada aqui!")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }